import React from "react";
import { useLocation } from "react-router-dom";
import Experiences from "@components/V3/Experiences";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const ExperiencePage = () => {
    const location = useLocation();

    return (
        <VersionedLayout>
            <Experiences key={location.pathname} />
        </VersionedLayout>
    );
};

export default ExperiencePage;
